import React from "react";

export function TestimonialsSection() {
  const testimonials = [
    {
      name: "Fam. Jansen",
      role: "Arnhem",
      quote:
        "Van advies tot installatie: uitstekend geregeld. Opbrengst is hoger dan verwacht en communicatie was top.",
    },
    {
      name: "MKB Klant",
      role: "Nijmegen",
      quote:
        "SOL-VI schakelde snel en dacht mee over fiscale voordelen. Installatie zonder overlast binnen één dag.",
    },
    {
      name: "R. de Vries",
      role: "Elst",
      quote:
        "Heldere offerte, nette montage en directe besparing zichtbaar. Aanrader!",
    },
  ];

  return (
    <section aria-labelledby="testimonials-heading" className="py-16">
      <div className="container mx-auto px-4">
        <header className="mb-8 text-center">
          <h2 id="testimonials-heading" className="text-3xl md:text-4xl font-bold tracking-tight">
            Klanten aan het woord
          </h2>
          <p className="text-muted-foreground mt-2">
            Echte ervaringen van particulieren en ondernemers in de regio Arnhem-Nijmegen.
          </p>
        </header>

        <div className="grid gap-6 md:grid-cols-3">
          {testimonials.map((t, i) => (
            <article key={i} className="bg-card text-card-foreground border border-border rounded-lg p-6 shadow-sm">
              <p className="italic">“{t.quote}”</p>
              <div className="mt-4 text-sm text-muted-foreground">
                <span className="font-medium text-foreground">{t.name}</span> · {t.role}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
